import classNames from 'classnames';
import { t } from 'ttag';
import { generatePath } from 'react-router-dom';

import { TabBar } from '@ui/TabBar';
import { Tab } from '@ui/Tab';
import { CreateComplain } from '@components/CreateComplain';
import * as path from '@urls';
import { useIsClient } from '@utils/common';

import s from './ProfileTabs.sss';

interface Props {
  className?: string,
  username: string,
  productsCount: number,
  positiveReviews: number,
  negativeReviews: number,
  postsCount: number,
  isCanComplain?: boolean,
  isCanWriteMessage?: boolean,
};

export const ProfileTabs: React.FC<Props> = ({
  className,
  username,
  productsCount,
  positiveReviews,
  negativeReviews,
  postsCount,
  isCanWriteMessage,
  isCanComplain,
}) => {
  const isClient = useIsClient();

  return (
    <TabBar className={classNames(s.root, className)}>
      <Tab exact={true} to={generatePath(path.publicMemberProfile, { username })}>
        {t`Мої товари`}
      &nbsp;
        <span className={s.count}>{productsCount}</span>
      </Tab>
      <Tab to={generatePath(path.memberSocialPosts, { username })}>
        {t`Огляди`}
        &nbsp;
        <span className={s.count}>
          {postsCount}
        </span>
      </Tab>
      <Tab to={generatePath(path.memberAsSellerReviews, { username })}>
        {t`Відгуки`}
      &nbsp;
        <span className={s.count}>{positiveReviews + negativeReviews}</span>
      </Tab>
      <Tab to={generatePath(path.aboutMemberProfile, { username })}>{t`Про мене`}</Tab>
      {isCanWriteMessage && (
        <Tab href={generatePath(path.dialogNewDirect, { username })}>
          {t`Написати`}
        </Tab>
      )}

      {isClient && isCanComplain && (
        <div className={s.complaintTab}>
          <CreateComplain username={username} />
        </div>
      )}
    </TabBar>
  );
};
